import { Image, Result, Typography } from "antd";
import CustomModal from "../CustomModal/CustomModal";
import SuccessImg from "../../assets/images/success.png";

const { Text, Title } = Typography;

const SuccessResultModal = ({
  open,
  onClose,
  title,
  subTitle,
  titleLevel = 4,
}) => (
  <CustomModal
    open={open}
    onCancel={onClose}
    centered
    content={
      <Result
        icon={<Image src={SuccessImg} preview={false} alt="Success" />}
        title={<Title level={titleLevel}>{title}</Title>}
        subTitle={
          subTitle ? (
            <Text style={{ color: "#40566D", fontSize: 14 }}>{subTitle}</Text>
          ) : null
        }
      />
    }
  />
);

export default SuccessResultModal;
